import Styled from 'styled-components';
import Arrows from '@catalogo/ui-americanas-desktop-svg/sort.svg';

const Wrapper = Styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  padding: 16px 16px 16px 18px;
`;

const SortIcon = Styled(Arrows)`
  fill: ${({ theme }) => theme.primaryColor};
  width: 13px;
  height: 13px;
`;

const SortTitle = Styled.span`
  display: flex;
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.titleTransform};
  font-size: ${({ theme }) => theme.fontSize.xs};
  margin: 0 6px 0 5px;
`;

const Option = Styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  fill: ${({ theme }) => theme.primaryColor};
  margin: 30px 0 0 0;
  
  > input {
    appearance: none;
    border: 2px solid #A9A9A9;
    width: 15px;
    height: 15px;
    border-radius: 50px;
    outline: none;
    margin: 0;

    &:checked {
    border: 4px solid ${({ theme }) => theme.primaryColor};
    background: #ffffff;
   }
  }

  > label {
    cursor: pointer;
    margin-left: 15px;
    font-size: 14px;
    
    &:hover {
      color: #000;
    }
  }
`;

const Label = Styled.div`
  color: #575757;
  text-transform: lowercase;
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

export { Wrapper, SortIcon, Label, SortTitle, Option };
